/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/star-blue': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8.00035 0.933105C8.25409 0.933105 8.48584 1.07715 8.59815 1.30469L10.5032 5.16408L14.7634 5.78678C15.0145 5.82348 15.2229 5.99948 15.3012 6.24082C15.3794 6.48216 15.3139 6.74699 15.1322 6.92401L12.05 9.92602L12.7774 14.1671C12.8203 14.4172 12.7175 14.67 12.5122 14.8191C12.3068 14.9683 12.0347 14.9879 11.81 14.8698L8.00035 12.8663L4.19065 14.8698C3.96604 14.9879 3.69384 14.9683 3.48852 14.8191C3.2832 14.67 3.18037 14.4172 3.22327 14.1671L3.95066 9.92602L0.868523 6.92401C0.686778 6.74699 0.621262 6.48216 0.699514 6.24082C0.777766 5.99948 0.986219 5.82348 1.23726 5.78678L5.4975 5.16408L7.40254 1.30469C7.51485 1.07715 7.7466 0.933105 8.00035 0.933105Z" fill="#1F63DB"/>'
  }
})
